import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { useGetPublisher } from 'api/publisher/hooks'
import NumberField from 'components/shared/inputs/NumberField'
import StatusSwitch from 'components/shared/inputs/StatusSwitch'
import Tag from 'components/shared/Tag'
import { Controller, useFormContext } from 'react-hook-form'
import { storage } from 'utils/localStorage'

const Placement = () => {
  const { control, watch } = useFormContext()
  const { data: publisher } = useGetPublisher({
    id: storage.getValue('publisherId'),
  })

  const virtualCurrencyName = watch('virtualCurrencyAttributes.name')

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Alert id="placement-hint" severity="info">
        This setting will be applied to the default placement of your
        application. You can always change your default placement or introduce
        new ones on the placements page.
      </Alert>

      {!virtualCurrencyName?.trim().length && (
        <Alert id="no-currency-hint" severity="info">
          Placement can only be added if a virtual currency is specified.
        </Alert>
      )}

      <Controller
        control={control}
        name="placementAttributes.status"
        render={({ field }) => (
          <StatusSwitch
            {...field}
            label="Placement Status"
            id="placementStatus"
            hasLive={true}
            hasTesting={false}
            sx={{ marginBottom: '12px' }}
          />
        )}
      />

      <Controller
        name="placementAttributes.exchangeRate"
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState }) => (
          <NumberField
            {...field}
            minValue={1}
            error={!!fieldState.error}
            helperText={fieldState.error ? 'This field is required' : null}
            id="exchangeRate"
            label="Exchange rate"
            endAdornment={`per 1 ${publisher?.currency}`}
          />
        )}
      />
      <Box display="flex" alignItems="center">
        <Controller
          name="placementAttributes.roundUp"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              {...field}
              id="roundUp"
              label="Round up low rewards to 1 unit of virtual currency"
              control={<Checkbox />}
            />
          )}
        />
        <Tag label="Recommended" color="success" />
      </Box>
    </Box>
  )
}

export default Placement
